export enum LocationStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    PendingApproval = 3,
    Purge = 4
}
